<div class="menubar-hoverable header-fixed menubar-pin" style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
  <div *ngIf="loading" class="col-md-12 col-lg-12 loader">
    <p class="rolling-img"><img src="../../assets/img_extend/Rolling.gif"></p>
    <span class="upload-text">{{ 'transportMigrationIsInProgressPleaseWait' | translate }}</span>
  </div>
<!-- header -->
<!--  -->


<!-- BEGIN BASE-->
<div id="base">

  <!-- BEGIN OFFCANVAS LEFT -->
  <div class="offcanvas">
  </div><!--end .offcanvas-->
  <!-- END OFFCANVAS LEFT -->

  <!-- BEGIN CONTENT-->
  <div id="content">
    <section class="has-actions style-default-bright">
      <div class="row">
        <div class="col-lg-12">
          <h2 class="text-primary">{{ 'transportation' | translate }}</h2>
        </div><!--end .col -->
        <div class="col-lg-8">
          <article class="margin-bottom-xxl">
            <p class="lead">
              {{ 'manageTransportationForTheAcademicYear' | translate }}
              <span style="color: var(--filter-dropdown-color)">
                  <select [(ngModel)]="academicInfo.current_academic" (change)="academicChanged()" style="border: none;">
                    <option *ngFor="let ac of academicInfo.academicList" [ngValue]="ac.pkAcademicId">
                        {{ ac.Year }}{{ac.current ? ('current'|translate):''}}
                    </option>

                  </select>
                </span>
            </p>
          </article>
        </div><!--end .col -->
        <div class="col-md-4" *ngIf="migrationStarted" style="margin-top: -9px;">
          <button type="button" class="btn ink-reaction btn-raised btn-xs btn-primary migrate" data-toggle="modal" data-target="#migrate-transport">
            <span style="margin-right: 5px;"><img src="https://img.icons8.com/material-sharp/100/000000/back-sorting.png" class="migrate-icon"></span>
            {{ 'migrateTransport' | translate }}</button>
        </div>
      </div>
      <!-- BEGIN -->
      <div class="col-md-12" style="padding: 0;">
        <div class="card tabs-left style-default-light">
          <ul class="card-head nav nav-tabs" data-toggle="tabs" style="cursor: pointer">
            <li class="active" (click)="getTransportCall('BUS')"><a data-toggle="tab" data-target="#buses">{{ 'buses' | translate }}</a></li>
            <li (click)="getTransportCall('ROUTE')"><a data-toggle="tab" data-target="#routes">{{ 'routes' | translate }}</a></li>
            <li (click)="getTransportCall('STOP')"><a data-toggle="tab" data-target="#stops">{{ 'stop' | translate }}</a></li>
            <li (click)="getTransportCall('TERMS')"><a data-toggle="tab" data-target="#settings">{{ 'terms' | translate }}</a></li>
          </ul>
          <div class="card-body tab-content style-default-bright">
            <div class="tab-pane active" id="buses">
              <div class="section-body">
                <div class="col-md-8 col-md-offset-2" style="border: 1px solid #d6d6d6;padding: 20px 0px 15px 10px;">
                  <div class="col-md-6" style="padding-top: 2em;">
                    <ul style="list-style: none;">
                      <li style="color: #616161;"><i class="fa fa-circle" style="color: #67b7dc;"></i> {{ 'activeTransportation' | translate }}: <span style="font-size: 15px;font-weight: 500;padding-left: 5px;">{{activeBus}}</span></li>
                      <li style="color: #616161;"><i class="fa fa-circle" style="color: #fdd400;"></i> {{ 'inactiveTransportation' | translate }}: <span style="font-size: 15px;font-weight: 500;padding-left: 5px;">{{inActiveBus}}</span></li>
                      <li style="font-size: 15px;color: #616161;"><span style="font-weight: 700;font-size: 30px;">{{totalVehicles}}</span> {{ 'totalVehicles' | translate }}</li>
                    </ul>
                  </div>
                  <div class="col-md-4 col-md-offset-2 text-center">
                    <img src="images_ext/transport.png" class="img-responsive" style="margin: 0 16px;">
                    <button style="background: var(--brand-primary-color);border: var(--brand-primary-color);padding: 2px 25px;float: right;" type="button" class="btn ink-reaction btn-raised btn-xs btn-primary add-new-vehicle" (click)="offcanvasAddTransport()">{{ 'addNewVehicle' | translate }}</button>
                  </div>
                </div>
                <div class="col-md-12" style="padding: 15px 0px;">
                  <div class="card card-underline">
                    <div class="card-head">
                      <ul class="nav nav-tabs pull-right" data-toggle="tabs" style="cursor: pointer">
                        <li (click)="getAllBuses()" class="active"><a data-toggle="tab" data-target="#all">{{ 'all' | translate }}</a></li>
                        <li (click)="getActiveBuses()"><a data-toggle="tab" data-target="#active">{{ 'active' | translate }}</a></li>
                        <li (click)="getInActiveBuses()"><a data-toggle="tab" data-target="#inactive">{{ 'inactive' | translate }}</a></li>
                      </ul>
                      <header>{{ 'vehicles' | translate }}</header>
                    </div>
                    <div class="card-body tab-content">
                      <!-- all vehicles -->
                      <div class="tab-pane active" id="all">
                        <table id="all-transport" class="display" cellspacing="0" width="100%">
                          <thead>
                          <tr>
                            <th>{{ 'bus' | translate }}</th>
                            <th>{{ 'driver' | translate }}</th>
                            <th>{{ 'busNumber' | translate }}</th>
                            <th>{{ 'busInCharge' | translate }}</th>
                            <th [style.display]="isAcademicChanged() ? '':'none'" class="text-center">{{ 'capacityUsed' | translate }}</th>
                            <th [style.display]="isAcademicChanged() ? 'none':''" class="text-center">{{ 'capacity' | translate }}</th>
                           <!-- <th>Tracking Id</th>-->
                            <th>{{ 'status' | translate }}</th>
                            <th>{{ 'manage' | translate }}</th>
                          </tr>
                          </thead>
                          <tbody>
                            <tr class="gradeX all-trans" style="text-align: center;" *ngIf="busList.length == 0">
                              <td colspan="7">
                                {{ 'noBusesAreAvailable' | translate }}
                              </td>
                            </tr>
                          <tr *ngFor="let blist of busList">
                            <td>{{blist.BusName}}</td>
                            <td>{{blist.staffName}}</td>
                            <td>{{blist.BusNumber}}</td>
                            <td>{{blist.busInChargeName}}</td>
                            <td [style.display]="isAcademicChanged() ? '':'none'" class="text-center"><a style="color: var(--brand-primary-color);cursor: pointer" (click)="getBusOptedStudentDetailsList(blist)">{{blist.Capacity}}({{blist.assignedStudents}})</a></td>
                            <td [style.display]="isAcademicChanged() ? 'none':''" class="text-center">{{blist.Capacity}}({{blist.assignedStudents}})</td>
                            <!--<td>{{blist.DeviceId}}</td>-->
                            <td>{{blist.BusStatus}}</td>
                            <td>
                              <a (click)="busDetail(blist,'all')" data-toggle="modal" data-target="#update-bus" class="btn btn-flat ink-reaction btn-default"><i class="fa fa-edit"></i></a>
                              <a *ngIf="blist.assignedStudents<=0" (click)="busDetail(blist,'all')" data-toggle="modal" data-target="#delete-bus" class="btn btn-flat ink-reaction"><i class="fa fa-trash"></i></a>
                              <a (click)="busDetail(blist,'all')" data-toggle="modal" data-target="#view-bus" class="btn btn-flat ink-reaction"><i class="fa fa-chevron-circle-down"></i></a>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- active vehicles -->
                      <div class="tab-pane" id="active">
                        <table id="active-transport" class="display nowrap" cellspacing="0" width="100%">
                          <thead>
                          <tr>
                            <th>{{ 'bus' | translate }}</th>
                            <th>{{ 'driver' | translate }}</th>
                            <th>{{ 'busNumber' | translate }}</th>
                            <th>{{ 'busInCharge' | translate }}</th>
                            <th [style.display]="isAcademicChanged() ? '':'none'">{{ 'capacityUsed' | translate }}</th>
                            <th [style.display]="isAcademicChanged() ? 'none':''">{{ 'capacity' | translate }}</th>
                            <th>{{ 'status' | translate }}</th>
                            <th>{{ 'manage' | translate }}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="gradeX all-trans" style="text-align: center;" *ngIf="activeBusList.length == 0">
                            <td colspan="7">
                              {{ 'noActiveBusesAreAvailable' | translate }}
                            </td>
                          </tr>
                          <tr class="gradeX all-trans" *ngFor="let ablist of activeBusList">
                            <td>{{ablist.BusName}}</td>
                            <td>{{ablist.staffName}}</td>
                            <td>{{ablist.BusNumber}}</td>
                            <td>{{ablist.busInChargeName}}</td>
                            <td [style.display]="isAcademicChanged() ? '':'none'" class="text-center"><a style="color: var(--brand-primary-color);cursor: pointer" (click)="getBusOptedStudentDetailsList(ablist)">{{ablist.Capacity}}({{ablist.assignedStudents}})</a></td>
                            <td [style.display]="isAcademicChanged() ? 'none':''" class="text-center">{{ablist.Capacity}}({{ablist.assignedStudents}})</td>
                            <td>{{ablist.BusStatus}}</td>
                            <td>
                              <a (click)="busDetail(ablist,'active')" data-toggle="modal" data-target="#update-bus" class="btn btn-flat ink-reaction btn-default"><i class="fa fa-edit"></i></a>
                              <a (click)="busDetail(ablist,'active')" data-toggle="modal" data-target="#delete-bus" class="btn btn-flat ink-reaction"><i class="fa fa-trash"></i></a>
                              <a (click)="busDetail(ablist,'active')" data-toggle="modal" data-target="#view-bus" class="btn btn-flat ink-reaction"><i class="fa fa-chevron-circle-down"></i></a>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- inactive vehicles -->
                      <div class="tab-pane" id="inactive">
                        <table id="inactive-transport" class="display nowrap" cellspacing="0" width="100%">
                          <thead>
                          <tr>
                            <th>{{ 'bus' | translate }}</th>
                            <th>{{ 'driver' | translate }}</th>
                            <th>{{ 'busNumber' | translate }}</th>
                            <th>{{ 'busInCharge' | translate }}</th>
                            <th>{{ 'capacityUsed' | translate }}</th>
                            <!--<th>Tracking Id</th>-->
                            <th>{{ 'status' | translate }}</th>
                            <th>{{ 'manage' | translate }}</th>
                          </tr>
                          </thead>
                          <tbody>
                            <tr class="gradeX all-trans" style="text-align: center;" *ngIf="inactiveBusList.length == 0">
                              <td colspan="7">
                                {{ 'noInactiveBusesAreAvailable' | translate }}"
                              </td>
                            </tr>
                          <tr *ngFor="let Iablist of inactiveBusList">
                            <td>{{Iablist.BusName}}</td>
                            <td>{{Iablist.staffName}}</td>
                            <td>{{Iablist.BusNumber}}</td>
                            <td>{{Iablist.busInChargeName}}</td>
                            <td>{{Iablist.Capacity}}({{Iablist.assignedStudents}})</td>
                            <!--<td>{{Iablist.DeviceId}}</td>-->
                            <td>{{Iablist.BusStatus}}</td>
                            <td>
                              <a (click)="busDetail(Iablist,'inactive')" data-toggle="modal" data-target="#update-bus" class="btn btn-flat ink-reaction btn-default"><i class="fa fa-edit"></i></a>
                              <a (click)="busDetail(Iablist,'inactive')" data-toggle="modal" data-target="#delete-bus" class="btn btn-flat ink-reaction"><i class="fa fa-trash"></i></a>
                              <a (click)="busDetail(Iablist,'inactive')" data-toggle="modal" data-target="#view-bus" class="btn btn-flat ink-reaction"><i class="fa fa-chevron-circle-down"></i></a>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="routes">
              <div class="row text-center" style="padding: 5px 0px;">
                <h4 style="color: gray;">{{ 'listOfAllRoutes' | translate }}</h4>
                <h4 style="color: gray;">{{ 'wantsToAddMoreRoutes' | translate }} <span data-toggle="modal" data-target="#add-new-routes" (click)="clearAddRouteData()" style="cursor: pointer;" class="newstops"><u>{{ 'clickHere' | translate }}</u></span></h4>
              </div>
              <div [style.display]="busRouteList.length > 0 ? 'none':''" class="col-md-12 text-center" style="color: var(--brand-primary-color);padding-top: 5em;">
                <h3>{{ 'noRouteAreAvailable' | translate }}</h3>
              </div>
              <div class="table-responsive" [style.display]="busRouteList.length > 0 ? '':'none'" style="padding: 0px 15px;">
                <table id="routes-table" class="table table-striped">
                  <thead>
                  <tr>
                    <th>{{ 'routeName' | translate }}</th>
                    <th>{{ 'startingPoint' | translate }}</th>
                    <th>{{ 'endingPoint' | translate }}</th>
                    <th>{{ 'totalStops' | translate }}</th>
                    <th>{{ 'assignViewStop' | translate }}</th>
                    <!--<th>View Stop</th>-->
                    <th>{{ 'manage' | translate }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="gradeX" *ngFor="let route of busRouteList">
                    <td>{{route.RouteName}}</td>
                    <td>{{route.startName}}</td>
                    <td>{{route.endName}}</td>
                    <td class="{{route.assignedStops < route.TotalStop ? 'stops-not-proper' : ''}}" (click)="showRouteWarning(route)">{{route.TotalStop}}</td>
                    <td>
                      <a class="btn btn-flat ink-reaction" data-toggle="modal" data-target="#assign_stop" (click)="routeDetail(route.pkRouteId,route);viewStopForRoute(route.pkRouteId,true)">
                        <i class="md md-assignment"></i></a>
                    </td>
                   <!-- <td>
                      <a class="btn btn-flat ink-reaction" data-toggle="modal" data-target="#view-stop" (click)="viewStopForRoute(route.pkRouteId,false)">
                        <i class="md md-view-module"></i></a>
                    </td>-->
                    <td>
                      <a class="btn btn-flat ink-reaction btn-default" data-toggle="modal" data-target="#edit-routes" (click)="routeDetail(route.pkRouteId,route)"><i class="fa fa-edit"></i></a>
                      <a (click)="routeDetail(route.pkRouteId,route)" data-toggle="modal" data-target="#delete-routes" class="btn btn-flat ink-reaction"><i class="fa fa-trash"></i></a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="tab-pane" id="stops">
              <div class="row text-center" style="padding: 5px 0px;">
                <h4 style="color: gray;">{{ 'listOfAllStop' | translate }}</h4>
                <h4 style="color: gray;">{{ 'wantsToAddMoreStop' | translate }} <span data-toggle="modal" data-target="#add-new-stops" (click)="clearAddStopData()" style="cursor: pointer;" class="newstops"><u>{{ 'clickHere' | translate }}</u></span></h4>
              </div>
              <div class="row">
                <div class="card">
                  <div class="card-body">
                    <div [style.display]="busStopDetail.length > 0 ? 'none':''" class="col-md-12 text-center" style="color: var(--brand-primary-color);padding-top: 5em;">
                      <h3>{{ 'noStopAreAvailable' | translate }}</h3>
                    </div>
                    <table id="stops_list_table" class="table table-striped no-margin">
                      <thead>
                      <tr>
                        <th>{{ 'stopName' | translate }}</th>
                        <th>{{ 'perTermFees' | translate }}({{currType}})</th>
                        <th>{{ 'noOfTerms' | translate }}</th>
                        <th>{{ 'manage' | translate }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let stops of busStopDetail">
                        <td>{{stops.BusStopName}}</td>
                        <td>{{stops.fare}}</td>
                        <td><i ></i> {{termCount}}</td>
                        <td>
                          <a class="btn btn-flat ink-reaction btn-default" data-toggle="modal" data-target="#edit-stops" (click)="stopDetail(stops.PkBusStopId)">
                            <i class="fa fa-edit"></i></a>
                          <a class="btn btn-flat ink-reaction" data-toggle="modal" data-target="#delete-stops" (click)="stopDetail(stops.PkBusStopId)">
                            <i class="fa fa-trash"></i></a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div><!--end .card-body -->
                </div>
              </div>
            </div>
            <div class="tab-pane" id="settings">
              <div class="row text-center" style="padding: 5px 0px;">
                <h4 style="color: gray;">{{ 'setupTermsForStops' | translate }}</h4>
                <h4 style="color: gray;">{{ 'createNewTerms' | translate }} <span data-toggle="modal" data-target="#add-new-term" (click)="clearAddTermData()" style="cursor: pointer;" class="newstops"><u>{{ 'clickHere' | translate }}</u></span></h4>
              </div>
              <div class="card-body tab-content">
              <div [style.display]="termsList.length > 0 ? 'none':''" class="col-md-12 text-center" style="color: var(--brand-primary-color);padding-top: 5em;">
                <h3>{{ 'noTermsAreAvailable' | translate }}</h3>
              </div>
              <table id="transport-term" class="display" [style.display]="termsList.length > 0 ? '':'none'" cellspacing="0" width="100%">
                <thead>
                <tr>
                  <th>{{ 'termName' | translate }}</th>
                  <th>{{ 'dueDate' | translate }}</th>
                                 <th>{{ 'termStart' | translate }}</th>
                                                  <th>{{ 'termEnd' | translate }}</th>
                  <th>{{ 'manage' | translate }}</th>
         
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let terms of termsList">
                  <td>{{terms.termName}}</td>
                  <td>{{terms.termDueDate | date}}</td>
                  <td>{{terms.termStartDate| date}}</td>
                      <td>{{terms.termEndDate| date}}</td>
                  <td>
                    <a class="btn btn-flat ink-reaction btn-default" data-toggle="modal" data-target="#edit-new-term" (click)="termDetail(terms.pkBusStopTermId)">
                      <i class="fa fa-edit"></i></a>
                    <a class="btn btn-flat ink-reaction" data-toggle="modal" data-target="#delete-term" (click)="deleteTermConfirm(terms.pkBusStopTermId)">
                      <i class="fa fa-trash"></i></a>
                  </td>
                </tr>
                </tbody>
              </table>
</div>
            </div>
          </div><!--end .section-body -->
        </div>
      </div>	<!-- END  -->
    </section>
  </div><!--end #content-->
  <!-- END CONTENT -->

  <!-- Menubar -->
  <!--  -->
  <!-- Model Box -->
  <!-- Add New Routes -->
  <div class="modal fade" id="add-new-routes" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="col-md-12 text-center" id="Route-Status" style="display: none;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding: 9.4em 0em;">
          <img src="images_ext/default.gif">
        </div>
        <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 10.25em 0em;">
          <img src="images_ext/double-directional-arrow.png">
          <h3>{{ 'addNewRoute' | translate }}</h3>
          <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
        </div>
        <div class="col-md-6" style="background-color: white;padding: 2em 1em;">
          <button id="addroutepopupclose" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
          <form class="form" role="form">
            <div class="form-group">
              <input type="text" class="form-control" id="name" [(ngModel)]="addRoutes.RouteName" name="routeName">
              <label for="name" style="font-size: small;">{{ 'routeName' | translate }}</label>
            </div>
            <div class="form-group">
              <select id="select2" name="startPoint" class="form-control" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="addRoutes.StartPoint">
                <option value=""></option>
                <option *ngFor="let stops of busStopDetail" value="{{stops.PkBusStopId}}">{{stops.BusStopName}}</option>
              </select>
              <label for="select2" style="font-size: small;">{{ 'startingPoint' | translate }}</label>
            </div>
            <div class="form-group">
              <select id="select1" name="endPoint" class="form-control" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="addRoutes.EndPoint">
                <option value=""></option>
                <option *ngFor="let stops of busStopDetail" value="{{stops.PkBusStopId}}">{{stops.BusStopName}}</option>
              </select>
              <label for="select1" style="font-size: small;">{{ 'endingPoint' | translate }}</label>
            </div>
            <div class="form-group">
              <input type="Number" class="form-control" id="stop" [(ngModel)]="addRoutes.TotalStops" name="no-of-stops">
              <label for="stop" style="font-size: small;">{{ 'noOfStops' | translate }}</label>
            </div>
            <div class="text-center" style="padding: 8px 0px;">
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="addBusRoute(addRoutes)">{{ 'add' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Add Routes -->
  <!-- Edit Routes -->
  <div class="modal fade" id="edit-routes" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="col-md-12 text-center" id="updateRoute-Status" style="display: none;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding: 9.4em 0em;">
          <img src="images_ext/default.gif">
        </div>
        <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 10.25em 0em;">
          <img src="images_ext/double-directional-arrow.png">
          <h3>{{ 'editRoute' | translate }}</h3>
          <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
        </div>
        <div class="col-md-6" style="background-color: white;padding: 2em 1em;">
          <button id="updateroutepopupclose" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
          <form class="form" role="form">
            <div class="form-group">
              <input type="text" class="form-control route_Name" id="component41" [(ngModel)]="myData.RouteName" name="routename" style="font-size: small;">
              <label for="component41" style="font-size: small;">{{ 'routeName' | translate }}</label>
            </div>
            <div class="form-group">
              <select id="select14" name="startPoint" class="form-control startpoint" [(ngModel)]="myData.StartPoint" style="font-size: small;">
                <option></option>
                <option *ngFor="let stops of busStopDetail" value="{{stops.PkBusStopId}}">{{stops.BusStopName}}</option>
              </select>
              <label for="select14" style="font-size: small;">{{ 'startingPoint' | translate }}</label>
            </div>
            <div class="form-group">
              <select id="select13" name="endPoint" class="form-control endpoint" [(ngModel)]="myData.EndPoint" style="font-size: small;">
                <option></option>
                <option *ngFor="let stops of busStopDetail" value="{{stops.PkBusStopId}}">{{stops.BusStopName}}</option>
              </select>
              <label for="select13" style="font-size: small;">{{ 'endingPoint' | translate }}</label>
            </div>
            <div class="form-group">
              <input type="Number" class="form-control totalStop" id="no-stops" [(ngModel)]="myData.TotalStop" name="no-of-stops" style="font-size: small;">
              <label for="no-stops" style="font-size: small;">{{ 'noOfStops' | translate }}</label>
            </div>
            <div class="text-center" style="padding: 8px 0px;">
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="updateBusRoute(updateRoutes)">{{ 'save' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Routes -->
  <!-- Add New Stops -->
  <div class="modal fade" id="add-new-stops" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" style="width: 90%; max-width: 1200px; margin: 30px auto;">
      <div class="modal-content">
        <div class="col-md-12 text-center" id="addStops-Status" style="display: none; position: absolute; background: rgba(255, 255, 255, 0.9); z-index: 999; padding: 8em 0;">
          <img src="images_ext/default.gif" alt="loading">
        </div>
        
        <div class="modal-header" style="background-color: var(--brand-primary-color); color: white; padding: 15px;">
          <button id="addstopspopupclose" type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: white; opacity: 1;">&times;</button>
          <div class="text-center">
            <img src="images_ext/bus-stops.png" alt="bus stop icon" style="max-width: 48px; margin-right: 15px; vertical-align: middle;">
            <h3 style="display: inline-block; margin: 0; vertical-align: middle;">{{ 'addBusStop' | translate }}</h3>
          </div>
        </div>

        <div class="modal-body" style="padding: 20px;">
          <div class="row">
            <!-- Left side form -->
            <div class="col-md-4" style="padding-right: 20px;">
              <form class="form" role="form">
                <div class="form-group">
                  <input type="text" class="form-control" id="component13" [(ngModel)]="addStop.BusStopName" name="stopsName">
                  <label for="component13">{{ 'stopName' | translate }}</label>
                </div>
                <div class="form-group">
                  <input type="number" class="form-control" id="fare" [(ngModel)]="addStop.fare" name="stopsName">
                  <label for="fare">{{ 'perTermFare' | translate }} ({{currType}})</label>
                </div>
                <div class="form-group" style="position: relative;">
                  <input type="text" class="form-control" id="addSearchLocation" placeholder="{{ 'searchLocation' | translate }}">
                  <label for="addSearchLocation">{{ 'searchLocation' | translate }}</label>
                </div>
                <div class="location-coordinates">
                  <div class="row">
                    <div class="col-xs-6">
                      <div class="form-group">
                        <input type="text" class="form-control" id="addLatitude" [(ngModel)]="addStop.Latitude" name="latitude" readonly>
                        <label for="addLatitude">{{ 'latitude' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-xs-6">
                      <div class="form-group">
                        <input type="text" class="form-control" id="addLongitude" [(ngModel)]="addStop.Longitude" name="longitude" readonly>
                        <label for="addLongitude">{{ 'longitude' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group text-right">
                  <button type="button" class="btn btn-raised ink-reaction btn-info" (click)="addBusStop(addStop)">{{ 'save' | translate }}</button>
                  <button type="button" class="btn btn-raised ink-reaction" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
                </div>
              </form>
            </div>
            
            <!-- Right side map -->
            <div class="col-md-8">
              <div class="map-container">
                <div id="addStopLocationMap" class="map"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of stops -->

  <!-- STOP TERMS POPUP -->
  <div class="modal fade" id="add-new-term" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="col-md-12 text-center" id="addterm-Status" style="display: none;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding: 8em 0em;">
          <img src="images_ext/default.gif">
        </div>
        <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 3.48em 0em; height: 371px;">
          <img src="images_ext/bus-stops.png">
          <h3>{{ 'addTerm' | translate }}</h3>
          <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
        </div>
        <div class="col-md-6" style="background-color: white;padding: 1em 1em;">
          <button id="addtermpopupclose" style="margin-top: -2em !important;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
          <form class="form" role="form">
            <div class="form-group">
              <input required type="text" class="form-control" id="termname" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="termName" name="termName">
              <label for="termname" style="font-size: small;">{{ 'termName' | translate }}</label>
            </div>
            <div class="form-group">
              <input required type="date" data-date-format="dd/mm/yyyy" class="form-control datepicker1" id="termdue" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="termDueDate" name="termDue">
              <label for="termdue" style="font-size: small;">{{ 'termDueDate' | translate }}</label>
            </div>
                 <div class="form-group">
              <input required type="date" data-date-format="dd/mm/yyyy" class="form-control datepicker1" id="termStartdate" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="termStartDate" name="termStart">
              <label for="termStart" style="font-size: small;">{{ 'termStart' | translate }}</label>
            </div>
                 <div class="form-group">
              <input required type="date" data-date-format="dd/mm/yyyy" class="form-control datepicker1" id="termEndDate" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="termEndDate" name="termEnd">
              <label for="termEnd" style="font-size: small;">{{ 'termEnd' | translate }}</label>
            </div>
            <div class="text-center" style="padding: 5px 0px;">
              <button id="add-term-btn" type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="addTerms()">{{ 'save' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="edit-new-term" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="col-md-12 text-center" id="editterm-Status" style="display: none;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding: 8em 0em;">
          <img src="images_ext/default.gif">
        </div>
        <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 3.48em 0em; height: 371px;">
          <img src="images_ext/bus-stops.png">
          <h3>{{ 'addTerm' | translate }}</h3>
          <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
        </div>
        <div class="col-md-6" style="background-color: white;padding: 1em 1em;">
          <button id="edittermpopupclose" style="margin-top: -2em !important;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
          <form class="form" role="form">
            <div class="form-group">
              <input required type="text" class="form-control" id="edittermname" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="edittermName" name="termName">
              <label for="termname" style="font-size: small;">{{ 'termName' | translate }}</label>
            </div>
            <div class="form-group">
              <input required type="date" data-date-format="dd/mm/yyyy" class="form-control datepicker1" id="edittermdue" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="edittermDueDate" name="termDue">
              <label for="termdue" style="font-size: small;">{{ 'termDueDate' | translate }}</label>
            </div>

              <div class="form-group">
              <input required type="date" data-date-format="dd/mm/yyyy" class="form-control datepicker1" id="editTermStartDate" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="editTermStartDate" name="termStart">
              <label for="termStart" style="font-size: small;">{{ 'termStart' | translate }}</label>
            </div>
              <div class="form-group">
              <input required type="date" data-date-format="dd/mm/yyyy" class="form-control datepicker1" id="editTermEndDate" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="editTermEndDate" name="termEnd">
              <label for="termEnd" style="font-size: small;">{{ 'termEnd' | translate }}</label>
            </div>
            <div class="text-center" style="padding: 5px 0px;">
              <button id="edit-term-btn" type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="editTerm()">{{ 'update' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- STOP TERMS POPUP END-->

  <!-- Update Bus Stops -->
  <div class="modal fade" id="edit-stops" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" style="width: 90%; max-width: 1200px; margin: 30px auto;">
      <div class="modal-content">
        <div class="col-md-12 text-center" id="stops-Status" style="display: none; position: absolute; background: rgba(255, 255, 255, 0.9); z-index: 999; padding: 8em 0;">
          <img src="images_ext/default.gif" alt="loading">
        </div>
        
        <div class="modal-header" style="background-color: var(--brand-primary-color); color: white; padding: 15px;">
          <button id="updateStopspopupclose" type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: white; opacity: 1;">&times;</button>
          <div class="text-center">
            <img src="images_ext/bus-stops.png" alt="bus stop icon" style="max-width: 48px; margin-right: 15px; vertical-align: middle;">
            <h3 style="display: inline-block; margin: 0; vertical-align: middle;">{{ 'editBusStop' | translate }}</h3>
          </div>
        </div>

        <div class="modal-body" style="padding: 20px;">
          <div class="row">
            <!-- Left side form -->
            <div class="col-md-4" style="padding-right: 20px;">
              <form class="form" role="form">
                <div class="form-group">
                  <input type="text" class="form-control stop-name" id="component21" [(ngModel)]="stopDetails.BusStopName" name="stopName">
                  <label for="component21">{{ 'stopName' | translate }}</label>
                </div>
                <div class="form-group">
                  <input type="number" class="form-control stop-fare" id="updatedfare" [(ngModel)]="stopDetails.Busfare" name="busfare">
                  <label for="updatedfare">{{ 'fare' | translate }} ({{currType}})</label>
                </div>
                <div class="form-group" style="position: relative;">
                  <input type="text" class="form-control" id="searchLocation" placeholder="{{ 'searchLocation' | translate }}">
                  <label for="searchLocation">{{ 'searchLocation' | translate }}</label>
                </div>
                <div class="location-coordinates">
                  <div class="row">
                    <div class="col-xs-6">
                      <div class="form-group">
                        <input type="text" class="form-control stop-latit" id="component22" [(ngModel)]="stopDetails.Latitude" name="latitude" readonly>
                        <label for="component22">{{ 'latitude' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-xs-6">
                      <div class="form-group">
                        <input type="text" class="form-control stop-long" id="component23" [(ngModel)]="stopDetails.Longitude" name="longitude" readonly>
                        <label for="component23">{{ 'longitude' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group text-right">
                  <button type="button" class="btn btn-raised ink-reaction btn-info" (click)="updateBusStop(updateStops)">{{ 'update' | translate }}</button>
                  <button type="button" class="btn btn-raised ink-reaction" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
                </div>
              </form>
            </div>
            
            <!-- Right side map -->
            <div class="col-md-8">
              <div class="map-container">
                <div id="stopLocationMap" class="map"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of stops -->
  <!-- Assign Stop -->
  <div class="modal fade" id="assign_stop" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="col-md-12 text-center" id="stopsAssign-Status" style="display: none;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding: 5em 0em;">
          <img src="images_ext/default.gif">
        </div>
        <div class="row text-center stops-bus">
          <h4>{{ 'assignStops' | translate }}</h4>
          <span>{{ 'total' | translate }} {{selectedRouteDetails.TotalStop}} {{selectedRouteDetails.TotalStop > 1 ? ('stops' | translate) : ('stop' | translate)}}</span>
        </div>
        <div class="col-md-12" id="addanotherStopParent" style="background-color: white;">
        </div>
        <div class="col-md-12" style="background-color: white;padding: 10px 0;">
          <div class="col-md-6">
            <button id="addmoreStop" type="button" class="btn ink-reaction btn-floating-action btn-primary" style="background: #E91E63 !important;width: 40px;height: 40px;margin: 0 !important;float: left;"><i class="fa fa-plus"></i></button>
          </div>
          <div class="col-md-6" style="padding: 4px;">
            <button id="assignStopsSavebutton" type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="assignStopForRoute(assignRouteStop)">{{ 'save' | translate }}</button>
            <button id="assignstoppopupclose" type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
          </div>
        </div>
        <!--<div class="row roots_for_bus" id="addanotherStop">
          <form class="form">
            <div class="form-group col-md-6">
              <select id="stoplist" name="stop-Name" class="form-control" [(ngModel)]="assignRouteStop.FkStopId">
                <option>Select Stop</option>
                <option *ngFor="let stops of busStopDetail" value="{{stops.PkBusStopId}}">{{stops.BusStopName}}</option>
              </select>
              <label for="stoplist" style="padding: 5px 13px;">Stop</label>
            </div>
            <div class="form-group col-md-6">
              <input type="text" class="form-control" id="stopnumber" name="assignStopNo" [(ngModel)]="assignRouteStop.stopNumber">
              <label for="stopnumber">Stop Number</label>
            </div>
          </form>
        </div>-->
      </div>
    </div>
  </div>
  <!-- End of Assign Stop -->
  <!-- Delete Routes -->
  <div class="modal fade" id="delete-routes" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog delete-modal">
      <div class="modal-content" style="padding: 1em 0;">
        <div class="header text-center thank-you-sides">
          <h3 class="modal-title popup-warning">{{ 'warning' | translate }}</h3>
          <img src="images_ext/exclamation.png">
        </div>
        <div class="popup-warning-text">
          <p>{{ 'doYouReallyWantToDeleteTheRoutes' | translate }} </p>
        </div>
        <div class="alert-button text-center">
          <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="deleteRouteDetail()">{{ 'delete' | translate }}</button>
          <button id="closedeleteroutepopup" type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="delete-term" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog delete-modal">
      <div class="modal-content" style="padding: 1em 0;">
        <div class="header text-center thank-you-sides">
          <h3 class="modal-title popup-warning">{{ 'warning' | translate }}</h3>
          <img src="images_ext/exclamation.png">
        </div>
        <div class="popup-warning-text">
          <p>{{ 'doYouReallyWantToDeleteTheTerm' | translate }} </p>
        </div>
        <div class="alert-button text-center">
          <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="deleteTerm()">{{ 'delete' | translate }}</button>
          <button id="closedeletetermpopup" type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Routes -->
  <!--Delete Stops-->
  <div class="modal fade" id="delete-stops" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog delete-modal">
      <div class="modal-content" style="padding: 1em 0;">
        <div class="header text-center thank-you-sides">
          <h3 class="modal-title popup-warning">{{ 'warning' | translate }}</h3>
          <img src="images_ext/exclamation.png">
        </div>
        <div class="popup-warning-text">
          <p>{{ 'doYouReallyWantToDeleteTheStop' | translate }} </p>
        </div>
        <div class="alert-button text-center">
          <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="deleteStopDetail()">{{ 'delete' | translate }}</button>
          <button id="closedeletestoppopup" type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
  <!--Delete Stops-->
  <!-- View Stop -->
  <div class="modal fade" id="view-stop" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" style="padding: 5em 1em;border: 10px dashed;">
        <div class="row text-center">
          <h4 style="color: blue;margin-top: -3em;">{{ 'stopListInRoute' | translate }}</h4>
        </div>
        <div class="row">
          <div class="card">
            <div class="card-body">
              <table class="table table-banded no-margin">
                <thead>
                <tr>
                  <th>{{ 'stopNumber' | translate }}</th>
                  <th>{{ 'stopNumber' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let vstop of viewStop">
                  <td>{{vstop.StopNumber}}</td>
                  <td>{{vstop.BusStopName}}</td>
                </tr>
                </tbody>
              </table>
            </div><!--end .card-body -->
          </div>
          <div class="col-md-12 text-right" style="padding: 8px 0px;position: fixed;bottom: 12em;margin-left: -3em;">
            <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'close' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- View Stop -->
  <!-- View bus -->
  <div class="modal fade" id="view-bus" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="width: 35em;">
      <div class="modal-content" style="padding-bottom: 10px;">
        <div class="col-md-12 view-bus-header">
          <h4 style="margin-top: 23px;">{{ 'busDetails' | translate }} - <i>{{busDetails.BusNumber}}</i></h4>
        </div>
        <div class="row">
          <div class="col-md-12" style="padding: 8px 2em;">
            <table style="width: 100%;">
              <tr><td><b>{{ 'busRoute' | translate }}</b></td><td class="text-right">&nbsp;{{busDetails.startName}}  &nbsp;<i class="fa fa-long-arrow-right" aria-hidden="true"></i>&nbsp;  {{busDetails.endName}} &nbsp;&nbsp;&nbsp;<i title="view/assign stops" style="cursor: pointer;" class="fa fa-chevron-circle-down" aria-hidden="true" data-dismiss="modal" data-toggle="modal" data-target="#assign_stop"  (click)="routeDetail(busDetails.fkRouteId,busDetails);viewStopForRoute(busDetails.fkRouteId,true)"></i></td></tr>
              <tr><td><b>{{ 'totalName' | translate }}</b></td><td class="text-right">&nbsp;{{busDetails.BusName}}</td></tr>
              <tr><td><b>{{ 'totalStops' | translate }}</b></td><td class="text-right">&nbsp;{{selectedBusData?.TotalStop}}</td></tr>
              <tr><td><b>{{ 'busTrackingId' | translate }}</b></td><td class="text-right">&nbsp;{{busDetails.DeviceId}}</td></tr>
              <tr><td><b>{{ 'totalSeats' | translate }}</b></td><td class="text-right">&nbsp;{{selectedBusData?.Capacity}}</td></tr>
              <tr><td><b>{{ 'filledSeats' | translate }}</b></td><td class="text-right">&nbsp;{{selectedBusData?.assignedStudents}}</td></tr>
              <tr><td><b>{{ 'remainingSeats' | translate }}</b></td><td class="text-right">&nbsp;{{convertToNumber(selectedBusData?.Capacity) - convertToNumber(selectedBusData?.assignedStudents)}}</td></tr>
            </table>
          </div>
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'close' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- View Bus -->
  <!-- Update Bus -->
  <div class="modal fade" id="update-bus" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" style="overflow: hidden;">
        <div class="row" style="margin: 0;display: flex;">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 0;display: flex;flex-direction: column;justify-content: center;align-items: center;min-height: 600px;position: relative;overflow: hidden;">
            <div style="position: absolute;top: 0;left: 0;right: 0;bottom: 0;background: url('images_ext/enrolltransport.png') center center no-repeat;background-size: cover;opacity: 0.1;"></div>
            <div style="position: relative;z-index: 1;padding: 2em;">
              <img src="images_ext/enrolltransport.png" style="max-width: 200px;margin-bottom: 1.5em;">
              <h3 style="margin: 0.5em 0;">{{ 'updateBus' | translate }}</h3>
              <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0.5em; margin-bottom: 0;">
            </div>
          </div>
    
          <div class="col-md-6" style="background-color: white;padding: 2em 1.5em;margin: 0;position: relative;">
            
            <div *ngIf="updateBusStatus" class="col-md-12 text-center" id="updateBus-Status" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.85); z-index: 1000; display: flex; justify-content: center; align-items: center;">
              <img src="images_ext/default.gif">
            </div>
            <button type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true" style="position: absolute;right: 10px;top: 10px;">&times;</button>
    
            <form class="form" role="form">
              <div class="form-group">
                <input type="text" class="form-control bus-number" id="editbusnumber" [(ngModel)]="busDetails.BusNumber" name="editbusNumber" style="font-size: small;">
                <label for="editbusnumber" style="font-size: small;">{{ 'busNumber' | translate }}</label>
              </div>
              
              <div class="form-group">
                <input type="text" class="form-control bus-name" id="editbusname" [(ngModel)]="busDetails.BusName" name="editbusName" style="font-size: small;">
                <label for="editbusname" style="font-size: small;">{{ 'busName' | translate }}</label>
              </div>
              
              <div class="form-group">
                <select id="driverNameedit" name="drivername" class="form-control bus-staff" [(ngModel)]="busDetails.fkStaffId" style="font-size: small;">
                  <option value=""></option>
                  <option *ngFor="let driver of driverDetails" value="{{driver.staffId}}">{{driver.DriverName}}</option>
                </select>
                <label for="driverNameedit" style="font-size: small;">{{ 'driverName' | translate }}</label>
              </div>
              
              <div class="form-group">
                <select id="busInCharge" name="busInCharge" class="form-control" [(ngModel)]="busDetails.BusInCharge" style="font-size: small;">
                  <option value=""></option>
                  <option *ngFor="let driver of driverDetails" value="{{driver.staffId}}">{{driver.DriverName}}</option>
                </select>
                <label for="busInCharge" style="font-size: small;">{{ 'busInCharge' | translate }}</label>
              </div>
              
              <div class="form-group">
                <input type="number" class="form-control bus-cap" id="editcapacity" [(ngModel)]="busDetails.Capacity" name="capacity" style="font-size: small;">
                <label for="editcapacity">{{ 'enterCapacity' | translate }}</label>
              </div>
              
              <div class="form-group">
                <select id="select15" name="select12" class="form-control bus-route" [(ngModel)]="busDetails.fkRouteId" style="font-size: small;">
                  <option></option>
                  <option *ngFor="let route of busRouteList" value="{{route.pkRouteId}}">{{route.RouteName}}</option>
                </select>
                <label style="font-size: small;">{{ 'defineRoute' | translate }}</label>
              </div>
              
              <div class="form-group" style="margin-top: 1.5em;">
                <label class="radio-inline radio-styled" style="cursor: initial;color: #b1b1b1;font-weight: 100;font-size: 12px;display: block;margin-bottom: 0.5em;">
                  <span>{{ 'selectVehicleStatus' | translate }}</span>
                </label>
                <div id="stat">
                  <label class="radio-inline radio-styled" style="margin-right: 1em;">
                    <input type="radio" class="bus-stat" name="active" [(ngModel)]="busDetails.BusStatus" value="RUNNING"><span>{{ 'active' | translate }}</span>
                  </label>
                  <label class="radio-inline radio-styled">
                    <input type="radio" class="bus-stat" name="active" [(ngModel)]="busDetails.BusStatus" value="NOT_RUNNING"><span>{{ 'inactive' | translate }}</span>
                  </label>
                </div>
              </div>
              
              <div class="text-center" style="padding: 15px 0px;">
                <button 
                  type="button" 
                  class="btn btn-raised ink-reaction btn-info" 
                  style="padding: 3px 20px;margin-right: 10px;" 
                  (click)="updateBusDetail(busDetails)"
                  [disabled]="updateBusStatus"
                >
                  <span *ngIf="!updateBusStatus">{{ 'update' | translate }}</span>
                </button>
                <button id="editbuspopup" type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Update Bus -->
  <!-- Delete Bus -->
  <div class="modal fade" id="delete-bus" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog delete-modal">
      <div class="modal-content" style="padding: 1em 0;">
        <div class="header text-center thank-you-sides">
          <h3 class="modal-title popup-warning">{{ 'warning' | translate }}</h3>
          <img src="images_ext/exclamation.png">
        </div>
        <div class="popup-warning-text">
          <p>{{ 'doYouReallyWantToDeleteTheBus' | translate }} </p>
        </div>
        <div class="alert-button text-center">
          <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="deleteBusDetail()">{{ 'delete' | translate }}</button>
          <button id="deletebuspopup" type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Delete Bus -->

  <!--MIGRATE TRANSPORT-->
  <div class="modal fade" id="migrate-transport" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog delete-modal">
      <div class="modal-content">
        <div class="header text-center thank-you-sides">
          <h3 class="modal-title popup-warning">{{ 'transportMigration' | translate }}</h3>
          <img src="../../assets/img_extend/migrate.png">
        </div>
        <div class="popup-warning-text">
          <p>{{ 'doYouWantToImportTransportDataSettingsFrom' | translate }}<br><b> {{previousAcademic?.Year}} to {{currentAcademicYear.Year}}</b> {{ 'academics' | translate }} </p>
        </div>
        <div class="alert-button text-center">
          <button type="button" class="btn btn-raised ink-reaction btn-info" (click)="migrateTransport()" data-dismiss="modal" style="padding: 3px 20px;">{{ 'yes' | translate }}</button>
          <button id="" type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'no' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

  <!-- BEGIN OFFCANVAS RIGHT -->
  <div class="offcanvas">
    <div id="offcanvas-add-trans" class="offcanvas-pane width-12" style="width:800px;    overflow-x: hidden;">
      <div *ngIf="busStatus" class="col-md-12 text-center" id="bus-Status" style="display: none;height: 100%;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding-top: 10em;">
        <img src="images_ext/default.gif">
      </div>
      <div class="offcanvas-head" style="    padding: 0;">
        <div class="col-md-6 text-center" style="background: var(--secondary-btn-bg-color);height: 100%;position: fixed;padding-top: 15em;">
          <p class="lead text-center" style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;">{{ 'addNewVehicle' | translate }}</p>
          <img src="images_ext/enrolltransport.png" class="img-responsive" style="margin: 0 auto;width: 100px;">
          <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'createYourNewVehileDetails' | translate }}</p>
        </div>
        <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
          <h3 id="addStClose" class="pull-right" style="color: grey;cursor: pointer;" data-dismiss="offcanvas"><i
              class="fa fa-close"></i></h3>
        </div>
        <div class="col-md-6" style="float: right;padding: 20px 20px;margin: 3em 0em;">
          <form class="form" role="form">
            <div class="form-group">
              <input type="text" class="form-control" id="busname" [(ngModel)]="addBus.BusName" name="busname">
              <label for="busname">{{ 'busName' | translate }}</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" id="regno" [(ngModel)]="addBus.BusNumber" name="busno">
              <label for="regno">{{ 'busNumber' | translate }}</label>
            </div>
            <div class="form-group col-md-6" style="padding-left: 0;">
              <select id="select11" name="drivername" class="form-control" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="addBus.fkStaffId">
                <option value=""></option>
                <option *ngFor="let driver of driverDetails" value="{{driver.staffId}}">{{driver.DriverName}}</option>
              </select>
              <label for="select11" style="font-size: small;">{{ 'driverName' | translate }}</label>
            </div>
            <div class="form-group col-md-6">
              <select id="in-charge" name="inChargeName" class="form-control" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="addBus.InChargeId">
                <option value=""></option>
                <option *ngFor="let driver of driverDetails" value="{{driver.staffId}}">{{driver.DriverName}}</option>
              </select>
              <label for="select11" style="font-size: small;">{{ 'busInCharge' | translate }}</label>
            </div>
            <div class="row" style="margin:0;">
              <div class="form-group col-md-6" style="padding-left: 0;">
                <input type="number" class="form-control" id="capacity" [(ngModel)]="addBus.Capacity" name="capacity">
                <label for="capacity">{{ 'enterCapacity' | translate }}</label>
              </div>
              <div class="form-group col-md-6" style="padding-left: 0;padding-right: 0;">
                <select id="select12" name="select12" class="form-control" style="color: rgba(49, 53, 52, 0.51);font-size: small;" [(ngModel)]="addBus.fkRouteId">
                  <option value=""></option>
                  <option *ngFor="let route of busRouteList" value="{{route.pkRouteId}}">{{route.RouteName}}</option>
                </select>
                <label style="font-size: small;">{{ 'defineRoute' | translate }}</label>
              </div>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" id="trackid" [(ngModel)]="addBus.DeviceId" name="device">
              <label for="trackid">{{ 'trackingDeviceId' | translate }}</label>
            </div>
            <div class="text-center">
              <label class="radio-inline radio-styled" style="cursor: initial;   color: #b1b1b1;font-weight: 100;padding-top: 4px;font-size: 12px;">
                <span>{{ 'selectVehicleStatus' | translate }}</span>
              </label>
              <label class="radio-inline radio-styled">
                <input type="radio" name="active" [(ngModel)]="addBus.BusStatus" value="RUNNING"><span>{{ 'active' | translate }}</span>
              </label>
              <label class="radio-inline radio-styled">
                <input type="radio" name="active" [(ngModel)]="addBus.BusStatus" value="NOT_RUNNING"><span>{{ 'inactive' | translate }}</span>
              </label>
            </div>
            <button type="button" class="btn btn-block ink-reaction btn-info" style="margin: 3em 0em;" (click)="addBuses(addBus)">{{ 'addBus' | translate }}</button>
          </form>
        </div>
      </div>
    </div>

    <!--STUDENT LIST FOR OPTED BUS-->
    <div id="studentListForOptedBus" class="offcanvas-pane width-12" style="width: 82vw;;overflow-x: hidden;">
      <div class="row text-center student-bus-header">
        <h3 class="pull-right" style="color: white;cursor: pointer;padding-right: 1em;" data-dismiss="offcanvas"><i (click)="closeStudentOptBusList()" class="fa fa-close"></i></h3>
        <h4 style="color: white;margin-top: 1.5em;margin-left: 4em;">{{ 'studentsListForOptedBus' | translate }}</h4>
        <img src="images_ext/transport.png" class="img-responsive student-bus-img">
      </div>
      <div class="student list" style="padding: 15px;">
        <div *ngIf="studentBusOptedListLoading" class="col-md-12 text-center no-student">
          <span>{{ 'fetchingStudentList' | translate }} <i class="fa fa-spinner fa-spin"></i></span>
        </div>
        <div *ngIf="!studentBusOptedListLoading && studentBusOptedList.length == 0" class="col-md-12 text-center no-student">
          <h3>{{ 'noStudentsAreAvailable' | translate }}</h3>
        </div>
        <table *ngIf="!studentBusOptedListLoading && studentBusOptedList.length > 0" id="student-list-for-opted-bus" class="table table-striped">
          <thead>
          <tr>
            <th>{{ 'name' | translate }}</th>
            <th>{{ 'parent' | translate }}</th>
            <th>{{ 'mobile' | translate }}</th>
            <th>{{ 'registrationNumber' | translate }}</th>
            <th>{{ 'class' | translate }}</th>
            <th>{{ 'busNumber' | translate }}</th>
            <th>{{ 'busName' | translate }}</th>
            <th>{{ 'capacity' | translate }}</th>
            <th>{{ 'routeName' | translate }}</th>
            <th>{{ 'busStop' | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let std of studentBusOptedList">
            <td>{{std.studentName}}</td>
            <td>{{std.parentName}}</td>
            <td>{{std.mobileNumber}}</td>
            <td>{{std.registrationId}}</td>
            <td>{{std.class}}</td>
            <td>{{std.BusNumber}}</td>
            <td>{{std.BusName}}</td>
            <td>{{std.Capacity}}</td>
            <td>{{std.RouteName}}</td>
            <td>{{std.BusStopName}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div><!--end #base-->
<!-- END BASE -->

<!-- BEGIN JAVASCRIPT -->

</div>
